import { useContext } from 'react';
import SessionHydrationContext from '~/contexts/SessionHydrationContext';

const useSessionHydration = () => {
  const { data, refetch } = useContext(SessionHydrationContext);
  return [data, refetch] as const;
};
export default useSessionHydration;
